import type { HorizontalScrollerAttributes } from '../../types/cms'
import ProductCard from '../ProductCard'
import { Box, Container } from '@mui/material'
import { MarkdownText, ScrollRowCarousel } from 'ui-kit'

const HorizontalScroller = ({
  headerTitle,
  product_cards,
}: HorizontalScrollerAttributes) => {
  const cards = product_cards?.data

  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        width: '100%',
        bgcolor: 'common.white',
        py: 8,
      }}
    >
      <Container maxWidth="xl">
        <ScrollRowCarousel
          title={
            typeof headerTitle === 'string' ? (
              <MarkdownText>{headerTitle}</MarkdownText>
            ) : null
          }
          titleStyles={{
            '& h1, & h2, & h3, & h4, & p': {
              m: 0,
            },
          }}
          contentHeight="37rem"
          showMobileArrows
          arrowsGutter={0}
        >
          {cards?.map(
            ({
              attributes: {
                info,
                logo,
                productImage,
                button,
                brandNameType,
                brandName,
              } = {},
            }) => (
              <ProductCard
                key={info}
                image={productImage}
                logo={logo}
                text={info}
                button={button}
                brandNameType={brandNameType}
                brandName={brandName}
              />
            ),
          )}
        </ScrollRowCarousel>
      </Container>
    </Box>
  )
}

export default HorizontalScroller
